module.exports = __webpack_public_path__ + "static/media/Ø1_2.bba7cdc2.png";